import React from 'react'
import { Field } from "formik";
import FieldWrapper from "./FieldWrapper.jsx";

const FieldEmail = ({
    id,
    displayName,
    disabled=false,
    placeholder = '',
    classNamePrefix='client-form'
}) => (
    <FieldWrapper 
        id={id} 
        displayName={displayName}
        typeClass="field-email"
        classNamePrefix={classNamePrefix}
    >
        <Field 
            id={id} 
            name={id} 
            type="email"
            disabled={disabled}
            placeholder={placeholder} 
        
        />
    </FieldWrapper>
)

export default FieldEmail